<ng-template [ngIf]="hasData" [ngIfElse]="noData">
	<property-detail-list [properties]="properties" [company]="company">
	</property-detail-list>
</ng-template>
<ng-template #noData>
	<div class="no-data">{{ Loc(LocalizedTextIds.NoDataAvailable) }}</div>
</ng-template>
